<template>
  <tr class="account-row">
    <td class="account-column">
      <div class="text-right">
        <img
          class="bank-image pull-left"
          v-bind:src="bankImage"
          v-bind:alt="ad.account.bankName"
          width="120"
          height="30"
        />
        
        <div class="pull-right apy-text" v-if="!ad.account.bonusAmount">
          <span class="apy" >{{$filters.percentageFilter(ad.account.apy)}}</span>
          <br />
          <apy-label class="apy-label"></apy-label>
        </div>
        <div class="pull-right apy-text" v-else>
          <span class="apy" >{{$filters.currencyFilter(ad.account.bonusAmount, 0) }}</span>
          <br />
          <span class="apy-label">Bonus* </span>
        </div>
      </div>
      <span class="clearfix"></span>
      <span class="bank-name" v-html="ad.account.bankName"></span>
      <div>
        <div class="account-name">
          <span v-if="ad.adCopy">
            {{ad.account.name}}<br/>
            <span v-html="ad.adCopy"></span>
          </span>
          <span v-else>
            {{ad.account.name}}
          </span>
        </div>
        <a
          href
          class="details pull-right"
          v-on:click.prevent="trackAdLink(ad)"
        >See Offer ></a>
      </div>
      <img class="pixel" width="1" height="1" alt v-bind:src="$filters.formatTrackingFilter(ad.pixel)" />
      <span class="clearfix"></span>
      <hr />
    </td>
  </tr>
</template>

<script lang="ts">
import Vue, { defineComponent } from "vue";
import "../../utils/filters";
import { adClickMixin } from "../../mixins/adClickMixin";
import apyLabel from "../../components/apyLabel.vue";

export default defineComponent({
  mixins: [adClickMixin],
  components: {
    apyLabel: apyLabel
  },
  props: {
    ad: { type: Object, required: true }
  },
  computed: {
    bankImage(): string {
      return `${process.env.VUE_APP_CONTENT_URI}/spnsr/${this.ad.account.bankUrl}/120x30.png`;
    }
  }
});
</script>
<style lang="scss" scoped>
.account-row {
  transition: all 0.2s ease-in-out;
  pointer-events: none;
}
.account-row:hover {
  box-shadow: 1px 1px 4px #aaa;
  .account-column {
    .details {
      > & span {
        text-decoration: none;
      }
    }
    & hr {
      visibility: hidden;
    }
  }
}
.account-column {
  border: none;
  padding: 12px;
  padding-bottom: 0;
  width: 298px;
  .apy-text {
    line-height: 14px;
    .apy {
      font-size: 18px;
      color: #4a4a4a;
      font-weight: 600;
    }
    .apy-label {
      font-size: 12px;
      font-weight: 600;
      color: #999;
    }
  }

  .bank-name {
    color: #000;
    padding-top: 2px;
  }
  .account-name {
    color: #666;
  }
  .details {
    pointer-events: all;
    &:hover {
      text-decoration: underline;
    }
    font-size: 14px;
    font-weight: 600;
  }
  img.pixel {
    display: none;
  }
  .bank-image {
    margin-bottom: 4px;
  }
  hr {
    margin-top: 11px;
    margin-bottom: 0;
    border-top: 1px solid #d9d9d9;
  }
}
</style>
